import { render, staticRenderFns } from "./aerialPhoto.vue?vue&type=template&id=004f72b6&scoped=true"
import script from "./aerialPhoto.vue?vue&type=script&lang=js"
export * from "./aerialPhoto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004f72b6",
  null
  
)

export default component.exports